import React from 'react'
import { Flex, Text, Button, Link , Image , Box} from '@pancakeswap/uikit'
import { useTranslation } from 'contexts/Localization'
import styled, { keyframes } from 'styled-components'
import CompositeImage, { CompositeImageProps } from '../CompositeImage'
import PurpleWordHeading from '../PurpleWordHeading'

interface SalesSectionButton {
  to: string
  text: string
  external: boolean
}

export interface SalesSectionProps {
  headingText: string
  bodyText: string
  reverse: boolean
  primaryButton: SalesSectionButton
  secondaryButton: SalesSectionButton
  images: CompositeImageProps
}

const SalesSection: React.FC<SalesSectionProps> = (props) => {
  const { t } = useTranslation()

  const { headingText, bodyText, reverse, primaryButton, secondaryButton, images } = props

  const headingTranslatedText = t(headingText)
  const bodyTranslatedText = t(bodyText)
 
  const ButtonText = styled(Text)`
  display: none;
  ${({ theme }) => theme.mediaQueries.xs} {
    display: block;
  }
`
const ScrollBox = styled(Box)`
padding: 10px;
background: radial-gradient(ellipse farthest-corner at right bottom, #FEDB37 0%, #FDB931 8%, #9f7928 30%, #8A6E2F 40%, transparent 80%),
radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%);
border: 0.05px solid ${({ theme }) => theme.colors.gold};
margin-right: 20px;
width: 200px;
margin-bottom: 20px;
border-radius: 20px;
${({ theme }) => theme.mediaQueries.md} {
  background: radial-gradient(ellipse farthest-corner at right bottom, #FEDB37 0%, #FDB931 8%, #9f7928 30%, #8A6E2F 40%, transparent 80%),
  radial-gradient(ellipse farthest-corner at left top, #FFFFFF 0%, #FFFFAC 8%, #D1B464 25%, #5d4a1f 62.5%, #5d4a1f 100%);  width: 180px;
  margin-right: 20px;
  border: 0.05px solid ${({ theme }) => theme.colors.gold};
  margin-bottom: 20px;
  padding: 10px;
  width: 200px; 
  border-radius: 10px; 
}
`
const ImageWrapper = styled.div`
margin: 0 auto;
${({ theme }) => theme.mediaQueries.md} {
  margin: 0 auto;

}
`
  return (
    <ScrollBox>

    <Flex flexDirection="column"   justifyContent="center"  alignItems="center"
    >
       <ImageWrapper>
        <img  src="/images/pixel/S2.png"  alt="ifo bunny" width="100px" height="100px"/>
      </ImageWrapper>
      <Text color="background"  bold fontSize="20px" mt="4px">
                    {t('Claim')}
                  </Text>
                  <Text color="text"  bold fontSize="14px" mt="4px">
                    {t('Receive free airdrops')}
                  </Text>
                  <Text color="text"  bold fontSize="14px" mt="4px">
                    {t('on a daily basis.')} 
                  </Text>
                  <Link  href="/airdrops">
              <Button  variant="tertiary" height="40px" mb="5px" mt="10px" width="100px">
              <ButtonText color="text" bold fontSize="14px">
          {t('CLAIM NOW')}
        </ButtonText>
              </Button>
            </Link>
      </Flex> 
                </ScrollBox>

  )
}

export default SalesSection